const rupeeDonations = `

#### Contribute to the Server Buff!
- Visit the **Service Manager** in **every city**.
- Participate in the **Rupees Donations Event** to **benefit the entire server**.

#### How It Works
- Donate **Rupees** to reach **100% goal**.
- Once the goal is achieved, a **random server-wide buff** will be activated.
- **Minimum donation:** **200 million Rupees** (counts as **1% progress**).

#### Possible Buffs
![Buff List 1](assets/guide/rupees_event_us_1.jpg)
![Buff List 2](assets/guide/rupees_event_us_2.jpg)
![Buff List 3](assets/guide/rupees_event_us_3.jpg)
![Buff List 4](assets/guide/rupees_event_us_4.jpg)
![Buff List 5](assets/guide/rupees_event_us_5.jpg)

Help power up the **entire server** with your generous donations! 💰✨`;

export default rupeeDonations;
